import { MemberDetailsLayoutProps } from '..';
import { statisticRequestTypeMapping, useMemberStatisticsData } from '@/pages/memberAdmin/admin/statistics/useStatisticsData';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { IMemberDetailStatisticWithdrawData } from '@/models/page/report/IReportMemberDetails';
import dayjs from 'dayjs';
import { numberComma } from '@/service/utils';
import Pagination from '@/components/pagination';
import { DEFAULT_PAGE_COUNT } from '@/models/apiRequest/baseRequest';
import { FloatHelper, RoundType } from '@/service/floatHelper';
import LoadingMask from '@/components/loadingMask/loadingMask';

// 提現
const MemberDetailsWithdraw = ({ memberDetail, requestData }: MemberDetailsLayoutProps) => {
    const [statistics, fetchHandler, isLoading] = useMemberStatisticsData<IMemberDetailStatisticWithdrawData>({
        memberPartnerId: memberDetail.PartnerId,
        memberUserName: memberDetail.UserName,
        queryDateRange: {
            startDate: requestData.DateFrom,
            endDate: requestData.DateTo,
        },
    });
    const { t } = useTranslation();

    const [currentPage, setPage] = useState(1);

    useEffect(() => {
        fetchHandler({
            StatisticType: statisticRequestTypeMapping.Withdraw,
            PartnerId: memberDetail.PartnerId,
            UserName: memberDetail.UserName,
            DateFrom: requestData.DateFrom,
            DateTo: requestData.DateTo,
            PageNo: currentPage,
            PageSize: DEFAULT_PAGE_COUNT,
        });
    }, [currentPage]);

    return (
        <>
            {statistics && statistics?.Summary?.TotalRecords > 0 && (
                <Table className="table">
                    <Thead className="table" style={{ width: 'calc( 100% - 1em )' }}>
                        <Tr>
                            <Th className="w-[50%]">{t('Lbl_WithdrawTime')}</Th>
                            <Th>
                                <div className="text-right">{t('Th_balance')}</div>
                            </Th>
                            <Th>{t('Th_status')}</Th>
                        </Tr>
                    </Thead>
                    <Tbody className=" block overflow-y-auto max-h-[200px] ">
                        {statistics &&
                            statistics.Data.map((entry, index) => (
                                <Tr key={index} className="table w-full table-fixed">
                                    <Td className="w-[50%]">{dayjs(entry.CreateTime).format('YYYY-MM-DD HH:mm:ss')}</Td>
                                    <Td>
                                        {' '}
                                        <div className="text-right">
                                            {'$' + numberComma(FloatHelper.floatFixed(parseFloat(entry.Amount.toString()), RoundType.Floor, 0))}
                                        </div>
                                    </Td>
                                    <Td>
                                        {entry.Status ? (
                                            <span key={entry.CreateTime} className="text-red-600">
                                                {t('Txt_success')}
                                            </span>
                                        ) : (
                                            <span key={entry.CreateTime} className="text-green-600">
                                                {t('Txt_fail')}
                                            </span>
                                        )}
                                    </Td>
                                </Tr>
                            ))}
                    </Tbody>
                </Table>
            )}

            {!isLoading && statistics && statistics?.Summary?.TotalRecords <= 0 && (
                <div className="my-4 flex justify-center">
                    <span className="text-3xl text-gray-400 icon icon-notification">{t('Lbl_NoRecord')}</span>
                </div>
            )}

            <div className="flex justify-center m-2">
                <span className=" text-gray-500 self-center mr-2">{t('Lbl_TotalRecord', { '0': statistics?.Summary.TotalRecords || 0 })}</span>
                <Pagination
                    pageCount={Math.ceil((statistics?.Summary.TotalRecords || 1) / DEFAULT_PAGE_COUNT)}
                    onPageChange={(e) => {
                        setPage(e.selected + 1);
                    }}
                />
            </div>

            <LoadingMask visible={isLoading} />
        </>
    );
};

export default MemberDetailsWithdraw;
